export const ICON_PHONE = 'telefony';
export const ICON_TABLET = 'planshety';
export const ICON_USB_MODEM = 'modemy-i-routery';
export const ICON_INTERNET_I_TV = 'internet-i-tv';
export const ICON_AUDIO = 'audio';
export const ICON_GADGETS = 'gadzhety';
export const ICON_ACCESSORIES = 'aksessuary';
export const ICON_TSIFROVYE_TOVARY = 'tsifrovye-tovary';
export const ICON_TSIFROVYE_PRODUCTY = 'tsifrovye-produkty';
export const ICON_ACTIONS = 'actions';
export const ICON_MERCH = 'merch_goods';
export const ICON_DEFAULT = 'default';
export const ICON_COMPUTERS = 'computers';
export const ICON_APPLIANCES = 'appliances';
export const ICON_TOVARY_DLIA_DOMA = 'tovary-dlia-doma';
export const ICON_KOMPIUTERNAIA_TECHNIKA = 'kompiuternaia-tekhnika';
export const ICON_SMART_HOME = 'smart-home';

export const definedIcons = {
  [ICON_PHONE]: 'telefony',
  [ICON_TABLET]: 'planshety',
  [ICON_INTERNET_I_TV]: 'modemy',
  [ICON_USB_MODEM]: 'modemy',
  [ICON_AUDIO]: 'audio',
  [ICON_GADGETS]: 'gadzhety',
  [ICON_ACCESSORIES]: 'aksessuary',
  [ICON_TSIFROVYE_TOVARY]: 'tsifrovye',
  [ICON_TSIFROVYE_PRODUCTY]: 'tsifrovye',
  [ICON_ACTIONS]: 'actions',
  [ICON_MERCH]: 'merch',
  [ICON_DEFAULT]: 'default',
  [ICON_COMPUTERS]: 'computers',
  [ICON_APPLIANCES]: 'appliances',
  [ICON_TOVARY_DLIA_DOMA]: 'tovaryDliaDoma',
  [ICON_KOMPIUTERNAIA_TECHNIKA]: 'kompiuternaiaTekhnika',
  [ICON_SMART_HOME]: 'smartHome',
};
